module.exports = __webpack_public_path__ + "img/share-icon.0bd22a15.svg";